import { Injectable } from "@angular/core";
import { doc, docData, Firestore } from '@angular/fire/firestore';
import { combineLatest, Observable } from "rxjs";
import { map } from "rxjs/operators";
import { AnnualRegistrationForm } from "../cotisation-form/inscription.model";
import { AnnualRegistration, YearInfo } from "./year-selection.model";

@Injectable({
  providedIn: 'root',
})
export class YearSelectionFirebaseQueryService {

  private registrationCollectionName = 'annual-registration-forms';
  constructor(private firestore: Firestore) { }

  getInscriptionInfosForYears(memberId: string, firstDatePractice: Date, periods: AnnualRegistration[]): Observable<YearInfo[]> {
    var year = new Date().getFullYear();
    var now = new Date();
    var filteredPeriods = periods.filter(p => p.formOpeningDate.getTime() <= now.getTime() && p.year > (year - 2))
    var periodsWithPractice = filteredPeriods.filter(p => p.endDate>=firstDatePractice);

    const obs = periodsWithPractice.map(a => this.getInscriptionInfosForYear(memberId, a));
    return combineLatest(obs);
  }

   private getInscriptionInfosForYear(
    memberId: string,
    period: AnnualRegistration
  ): Observable<YearInfo> {

    const year = String(period.year);

    // Build Firestore document references
    const memberDoc = doc(
      this.firestore,
      `${this.registrationCollectionName}/${year}/members/${memberId}`
    );

    // docData returns an observable of the document
    return docData(memberDoc).pipe(
      map(form => ({
        year: Number(year),
        state: (form as AnnualRegistrationForm)?.state ?? '',
        pdfDocumentId: (form as AnnualRegistrationForm)?.pdfDocumentId ?? ''
      }))
    );
  }
}